module.exports = __webpack_public_path__ + "img/wagon_2.08a976e4.png";